/**
 * Rapporterer klient-side krasj til serverloggen (POST /api/client-error) for
 * diagnose av intermitterende feil. Strupet så et krasj-loop ikke spammer.
 */
let lastReport = 0;

export function reportClientError(error: unknown, componentStack?: string | null): void {
  try {
    const now = Date.now();
    if (now - lastReport < 5000) return; // maks ett kall per 5 sek
    lastReport = now;
    const e = error as { message?: string; stack?: string } | null;
    fetch('/api/client-error', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({
        message: String(e?.message ?? error),
        stack: String(e?.stack ?? '').slice(0, 4000),
        componentStack: componentStack ? componentStack.slice(0, 2000) : null,
        url: location.href,
        userAgent: navigator.userAgent,
      }),
    }).catch(() => {});
  } catch {
    /* aldri la rapportering kaste videre */
  }
}
